
import React, { useEffect, useState } from 'react'
import { Comment, Avatar, Form, Button, List, Input } from 'antd';
import { useData } from '../../../../data'
import moment from 'moment';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'

const AddComment = (props) => {
    const [comments, setComments] = useState([])
    const [form] = Form.useForm();
    const data = useData()
    const jobs = data.jobs()

    useEffect(() => {
        setComments(props.job.comments)
    }, [props.job])

    const CommentList = ({ comments }) => (
        <List
            dataSource={comments}
            itemLayout="horizontal"
            renderItem={item => (

                < Comment
                    avatar={<Avatar src="https://joeschmoe.io/api/v1/random" alt="Han Solo" />}
                    author={item.user}
                    content={item.comment}
                    datetime={moment.utc(item.created_at, "YYYY-MM-DD H:mm:ss a").fromNow()}
                />
            )
            }
        />
    );
    const onFinish = (values) => {
        if (props.job.id) {
            trackPromise(
                jobs.saveComments
                    (props.job.id, values.comment_value)
                    .then(data => {
                        props.refresh()
                        form.resetFields();
                    })
                    .catch(error => {
                        console.log(error)
                    }), 'saveComments'
            )
        }
    }
    const Editor = ({ value }) => (
        <Form
            name="basic"
            form={form}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}>
            <Form.Item name="comment_value">
                <Input.TextArea rows={2} value={value} />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">
                    Add Comment
                </Button>
            </Form.Item>
        </Form>
    );

    return (
        <>
            {comments.length > 0 && <CommentList comments={comments} />}
            <Comment
                avatar={<Avatar src="https://joeschmoe.io/api/v1/random" alt="Han Solo" />}
                content={
                    <Editor
                    />
                }
            />
        </>
    );

}

export default AddComment;